import { render, staticRenderFns } from "./GuiaSPSADT.vue?vue&type=template&id=265349a5&"
import script from "./GuiaSPSADT.vue?vue&type=script&lang=js&"
export * from "./GuiaSPSADT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports